<template>
  <div v-if="item.alternateItems" class="card alternate-items">
    <h2 class="card-header alternate-items-heading font-weight-bold">{{ $t('alternateItems') }}</h2>
    <div class="card-body alternate-items-body px-2">
      <div
        class="alternate-item d-flex justify-content-between"
        v-for="asc in item.alternateItems"
        :key="asc.id"
      >
        <div class="alternate-item-description">
          <router-link
            class="text-primary font-weight-bold underline-link-from-center"
            :to="`/i/${asc.id}`"
            :id="asc.id"
            >{{ asc.name }}
            <span v-if="asc.ascQuantity != item.ascQuantity">
              - {{ $t('packOf') }} {{ asc.ascQuantity }}</span
            ></router-link
          >
          <div class=" item-pricing" v-if="!shouldHideItemPrices">
            <div v-if="asc.actualPrice != null && asc.actualPrice >= 0">
              <span class="price-new">{{ $t('seePriceInCart') }}</span>
            </div>
            <div v-if="asc.actualPrice == null || asc.actualPrice < 0">
              <span class="price-new">{{ $t('callForPrice') }}</span>
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-end flex-fill pl-2">
          <div class="wc-card-button" v-if="!shouldHideItemPrices">
            <WCBasicAddToCartButton
              v-if="!asc.hasModifiers && showAddToCartButton"
              :item="asc"
              class="btn-block"
              :describedBy="asc.id"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import WCBasicAddToCartButton from '@/modules/cart/components/WCBasicAddToCartButton/WCBasicAddToCartButton.vue';
import HidePricingMixin from '@/mixins/HidePricingMixin';
import { PropType, defineComponent } from 'vue';
import ItemDetail from '@/models/entities/items/item-detail';

export default defineComponent({
  components: { WCBasicAddToCartButton },
  mixins: [HidePricingMixin],
  props: {
    item: {
      type: Object as PropType<ItemDetail>,
      required: true,
    },
    showAddToCartButton: {
      type: Boolean,
      default: true,
    },
  },
});
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

.alternate-item {
  padding-top: $pad-1;
  padding-bottom: $pad-1;

  &:first-child {
    padding-top: 0;
  }
  &:last-child {
    padding-bottom: 0;
  }

  .wc-card-button {
    width: rem(150px);
  }
}

.alternate-items {
  border: 0;
}

.alternate-items-heading {
  background-color: var(--secondary-lighter-7, get-color('secondary', 'lighter-7'));
}
</style>
